module.exports = __webpack_public_path__ + "img/add.e6f3da42.svg";